<script setup lang="ts">
import ScPage from '@/components/common/page/ScPage.vue';
import { onMounted, ref, shallowRef } from 'vue';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import { request } from '@/util/request';
import { windows } from '@/components/common/window/Windows';
import Payment from '@/views/home/Payment.vue';

const setting = ref();
onMounted(async () => {
  const res = await request('/management/setting/get', { key: 'app' });
  if (res) {
    setting.value = res.value;
  }
});

const products = ref();
onMounted(async () => {
  const res = await request('/management/product/list');
  if (res) {
    products.value = res.list;
  }
});

async function buy(product: { id: string; name: string }) {
  const res = await request('/management/product/buy', {
    id: product.id,
  });
  if (!res) {
    return;
  }
  windows.open({
    content: {
      type: 'component',
      component: shallowRef(Payment),
      props: {
        order: res.order,
        qrUrl: res.qrUrl,
      },
    },
    title: '扫码支付',
    width: 400,
    height: 500,
    mask: true,
  });
}
</script>

<template>
  <sc-page title="套餐购买">
    <div style="width: 100%; padding: 20px">
      <div class="line" style="font-weight: bold">账号等级说明</div>
      <div v-html="setting?.levelDesc" />
      <div class="line" style="font-weight: bold">商品列表</div>
      <div class="line" style="display: flex; flex-direction: row">
        <a-card
          size="small"
          style="min-width: 200px; margin: 0 20px 20px 0"
          :title="product.name"
          v-for="(product, index) in products"
          :key="index"
        >
          <div>价格：{{ product.price }}元</div>
          <div>充值天数：{{ product.duration }}天</div>
          <div style="margin-top: 12px; text-align: right">
            <sc-btn
              :handler="() => buy(product)"
              size="small"
              type="primary"
              text="立即购买"
            />
          </div>
        </a-card>
      </div>
    </div>
  </sc-page>
</template>

<style scoped lang="scss">
.space-between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.line {
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}

.desc {
}
</style>
